import React from 'react'
import { Link } from "react-router-dom";
import "./cleannav.scss";

import AuthButton from "../Auth/AuthButton.js"; 

const CleanNav = () => {
  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">   
        <div className="collapse navbar-collapse justify-content-end">
          <div className="d-flex align-items-top">
            <ul className="navbar-nav ms-auto flex-nowrap">
              <li className="nav-item dropdown">
                <a href="/" className="nav-link px-sm-3 px-3 pb-sm-0" id="dropdownCollapse" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="bi bi-list h3"></i>
                </a>
                <ul className="dropdown-menu dropdown-menu-end text-small shadow" aria-labelledby="dropdownCollapse">
                  <li><Link to="/" className="dropdown-item">Home</Link></li>
                  <li><Link to="/about" className="dropdown-item">About</Link></li>
                  <li><Link to="/contact" onClick={() => {window.location.href="/contact"}} className="dropdown-item">Contact Us</Link></li>
                </ul>
              </li>
              <AuthButton/>
            </ul>
          </div>
        </div>
      </div>  
    </nav>
  );
  
}

export default CleanNav